import { connect } from 'react-redux'
import AssignmentsComponent from '../../../components/employer/assignments/assignments.component'
import {
  getAssignments,
  previewNewAssignment,
  addNewAssignment,
  cancelEditAssignment,
  closeAssignmentSnackbar,
  getLightEntrepreneurs,
  getFieldOfWork,
  saveAssignmentAsDraft,
  getTotalApplications,
  getAreaOfWork,
  getEmployerContractList,
  openAssignmentFormDialog,
  closeAssignmentFormDialog,
  completeOfferForm,
  copyPreviousAssignment,
  cancelOffer,
  openWarningCloseCompleteOfferForm,
  closeWarningCloseCompleteOfferForm,
  previewAssignment,
  signSendContract,
  getOfferFromLightEntre,
  assignmentPageChange,
  loadProfileStart
} from '../../../actions/employer'
import { groupLightEntrepreneurByUuid } from '../../../utils/employer/lightEntrepreneurs.utils'

const mapStateToProps = (state) => {
  const lightEntre = groupLightEntrepreneurByUuid(
    state.lightEntrepreneurs.lightEntre
  )
  const emailArray = lightEntre.map((obj) => ({
    email: obj.email,
    firstname: obj.firstname,
    lastname: obj.lastname,
    pinned_fav_lightentrepreneur: obj.pinned_fav_lightentrepreneur
  }))
  // const emailArray = lightEntre.map((obj) => obj.email)
  const assignmentList = state.assignments.assignmentRows
  const directlyOfferData = state.applications.directlyOfferData
  const modifiedAssignmentData = replaceItemsByAssignmentId(
    assignmentList,
    directlyOfferData
  )
  return {
    state,
    assignmentList: modifiedAssignmentData,
    enableSaveButton: state.assignments.enableSaveButton,
    assignmentFormValues: state.assignments.assignmentFormValues,
    showPreview: state.assignments.showPreview,
    isEdit: state.assignments.isEdit,
    showSnackbarAdd: state.assignments.showSnackbarAdd,
    showSnackbarUpdate: state.assignments.showSnackbarUpdate,
    showFailedSnackbar: state.assignments.showFailedSnackbar,
    fieldOfWork: state.companyProfile.fieldOfWork,
    emailArray: emailArray,
    showDraftSnackbar: state.assignments.showDraftSnackbar,
    showFailedDraftSnackbar: state.assignments.showFailedDraftSnackbar,
    showDeleteSnackbar: state.assignments.showDeleteSnackbar,
    assignmentEdit: state.assignments.assignmentEdit,
    areaOfWork: state.assignments.areaOfWork,
    openAssignmentForm: state.assignments.openAssignmentForm,
    offerFromLightEntre: state.assignments.offerFromLightEntre,
    offerToEntrepreneur: state.assignments.offerToEntrepreneur,
    showAskOfferContract: state.assignments.showAskOfferContract,
    showContractOfferForm: state.assignments.showContractOfferForm,
    openWarningCloseCompleteForm:
      state.assignments.openWarningCloseCompleteForm,
    latestAssignmentData: state.assignments.latestAssignmentData,
    showLeItemLoader: state.loader.showLeItemLoader,
    enableSendOrSignButton: state.assignments.enableSendOrSignButton,
    loadSignAndSend: state.loader.loadSignAndSend,
    selected: state.assignments.selected,
    pageSize: state.assignments.pageSize,
    showSnackbarSendOffer: state.assignments.showSnackbarSendOffer,
    showFailSnackbarSendOffer: state.assignments.showFailSnackbarSendOffer
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    getAssignments: () => dispatch(getAssignments()),
    previewNewAssignment: (values) => dispatch(previewNewAssignment(values)),
    addNewAssignment: (values, isDirectlyOffer) =>
      dispatch(addNewAssignment(values, isDirectlyOffer)),
    cancelEditAssignment: () => dispatch(cancelEditAssignment()),
    closeAssignmentSnackbar: () => dispatch(closeAssignmentSnackbar()),
    getLightEntrepreneurs: () => dispatch(getLightEntrepreneurs()),
    getFieldOfWork: () => dispatch(getFieldOfWork()),
    saveAssignmentAsDraft: (values) => dispatch(saveAssignmentAsDraft(values)),
    getTotalApplications: () => dispatch(getTotalApplications()),
    getAreaOfWork: () => dispatch(getAreaOfWork()),
    getEmployerContractList: () => dispatch(getEmployerContractList()),
    openAssignmentFormDialog: () => dispatch(openAssignmentFormDialog()),
    closeAssignmentFormDialog: () => dispatch(closeAssignmentFormDialog()),
    completeOfferForm: (selected) => dispatch(completeOfferForm(selected)),
    copyPreviousAssignment: () => dispatch(copyPreviousAssignment()),
    cancelOffer: () => dispatch(cancelOffer()),
    openWarningCloseCompleteOfferForm: () =>
      dispatch(openWarningCloseCompleteOfferForm()),
    closeWarningCloseCompleteOfferForm: () =>
      dispatch(closeWarningCloseCompleteOfferForm()),
    previewContract: (formData, isDirectOffer) =>
      dispatch(previewAssignment(formData, isDirectOffer)),
    signSendContract: (trim, isDraft, offeredData, directlySendContract) =>
      dispatch(
        signSendContract(trim, isDraft, offeredData, directlySendContract)
      ),
    assignmentPageChange: (selected) =>
      dispatch(assignmentPageChange(selected)),
    getOfferFromLightEntre: () => dispatch(getOfferFromLightEntre()),
    loadProfileStart: () => dispatch(loadProfileStart())
  }
}

// Replace assignment record with the one that have agreement data
const replaceItemsByAssignmentId = (originalArray, newItems) => {
  const updatedArray = originalArray.map((item) => {
    const replacement = newItems.find(
      (newItem) => newItem.assignment_id === item.assignment_id
    )
    return replacement ? replacement : item
  })
  return updatedArray
}

const AssignmentsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AssignmentsComponent)

export default AssignmentsContainer
